import { connect } from 'react-redux';
import { CasesListFilters } from './CasesListFilters';
import { getAllQueries, getCasesCollectionLoading, getDefaultColumns, getExportCasesLoading, getQueriesSelected, getQueriesToShow, getQueryListForFilterEdit, getQuerySelectedLabel, } from 'src/redux/cases/casesSelectors';
import { casesActions } from 'src/redux/cases/casesActions';
import { getI18n } from 'src/redux/core/coreSelectors';
import { getAutoPlayPermission } from 'src/redux/auth/authSelectors';
var mapStateToProps = function (state) { return ({
    i18n: getI18n(state),
    allQueries: getAllQueries(state),
    queryForFilterEdit: getQueryListForFilterEdit(state),
    queryToShow: getQueriesToShow(state),
    defaultColumns: getDefaultColumns(state),
    queriesSelected: getQueriesSelected(state),
    queriesSelectedLabel: getQuerySelectedLabel(state),
    isCasesLoading: getCasesCollectionLoading(state),
    isExportCasesLoading: getExportCasesLoading(state),
    hasAutoPlayPermission: getAutoPlayPermission(state),
}); };
var mapDispatchToProps = function (dispatch) { return ({
    updateFilters: function (newFilters) { return dispatch(casesActions.updateSearchFilterRequested(newFilters)); },
    resetFilters: function () { return dispatch(casesActions.resetFilters()); },
    updateAutoPlay: function (value) { return dispatch(casesActions.updateAutoPlay(value)); },
}); };
export default connect(mapStateToProps, mapDispatchToProps)(CasesListFilters);
